import {addHash} from './addHash';

export function isCurrentHashBase(targetHash?: string, currentHash: string = document.location.hash): boolean {
    const targetHashBase = addHash(targetHash).split('/')[1];
    const currentHashBase = addHash(currentHash).split('/')[1];

    return targetHashBase === currentHashBase;
}
